<template>
  <div id="ag-grid-cnic-compiler">
    <div id="div-with-loading" class="vs-con-loading__container">
      <!-- TODO: Uncomment when needed -->
      <!-- Month & year picker -->
      <!-- <div class="vx-row month-picker flex justify-content-start">
        <v-select
          v-validate="'required'"
          name="cnicCompiler-month"
          data-vv-validate-on="blur"
          class="w-full"
          v-model="cnicCompiler.month"
          :options="formCNICCompilerMonths"
          :clearable="false"></v-select>

        <v-select
          v-validate="'required'"
          name="cnicCompiler-month"
          data-vv-validate-on="blur"
          class="w-full"
          v-model="cnicCompiler.year"
          :options="formCNICCompilerYears"
          :clearable="false"></v-select>
      </div> -->

      <!-- Consolidated Numbers & Compiler Actions -->
      <div class="compiler-actions-row vx-row flex justify-between">
        <div class="compiler-numbers flex flex-wrap">
          <div class="compiler-numbers__rebate-amount ml-3">
            <div class="tag">Rebate Amount</div>
            <span>{{ metaRebateAmount }}</span>
          </div>

          <div class="compiler-numbers__partners-in-list">
            <div class="tag">Partners In List</div>
            <span>{{ metaPartnersInList }}</span>
          </div>

          <div class="compiler-numbers__days-till-deadline" v-if="formData.status.value == 'pending'">
            <div class="tag">Days Till Deadline</div>
            <span>{{ metaDaysTillDeadline }}</span>
          </div>
        </div>

        <div class="compiler-actions flex justify-content-end mr-4">
          <div class="mr-3" v-if="formData.cnicFormat['fileName']">
            <div class="tag">Status:</div>
            <v-select
            :name="`status`"
            class="cnic-compiler-status w-full"
            v-model="formData.status"
            :options="formStatus"
            :clearable="false"
            append-to-body
            :selectable="option => option.stage == formData.status.stage + 1"
            @option:selecting="setPreviousStatus(formData.status)"
            @input="openUploadConfirmationPopup()"
            :disabled="formData.status == 'paid'" >
            </v-select>
          </div>

          <div class="mr-3" v-if="formData.settlementConfirmation['fileName']">
            <div class="tag">Settlement Confirmation:</div>
            <div class="upload-input relative">
              <vs-button
                class="upload-btn flex align-center"
                type="filled"
                icon-pack="feather"
                icon="icon-file-text"
                @click="downloadFile(formData.settlementConfirmation['fileURL'])">
                {{ formData.settlementConfirmation['fileName'] }}
                </vs-button>
              <span
                style="
                  position: absolute;
                  right: 0;
                  bottom: 0;
                  transform: translate(-60%, -10%);">
                <feather-icon
                  icon="DownloadIcon"
                  color="primary"
                  class="primary cursor-pointer"
                  style="width: 15px; height: 15px; color: #000000"/>
              </span>
            </div>
          </div>

          <div class="mr-3" v-if="formData.emailConfirmation['fileName']">
            <div class="tag">Email Confirmation:</div>
            <div class="upload-input relative">
              <vs-button
                class="upload-btn flex align-center"
                type="filled"
                icon-pack="feather"
                icon="icon-file-text"
                @click="downloadFile(formData.emailConfirmation['fileURL'])">
                {{ formData.emailConfirmation['fileName'] }}
                </vs-button>
              <span
                style="
                  position: absolute;
                  right: 0;
                  bottom: 0;
                  transform: translate(-60%, -10%);">
                <feather-icon
                  icon="DownloadIcon"
                  color="primary"
                  class="primary cursor-pointer"
                  style="width: 15px; height: 15px; color: #000000"/>
              </span>
            </div>
          </div>

          <div class="mr-3" v-if="formData.cnicFormat['fileName']">
            <div class="tag">CNIC Format:</div>
            <div class="upload-input relative">
              <vs-button
                class="upload-btn flex align-center"
                type="filled"
                icon-pack="feather"
                icon="icon-file-text"
                @click="downloadFile(formData.cnicFormat['fileURL'])">
                {{ formData.cnicFormat['fileName'] }}
              </vs-button>
              <span style="position: absolute;
                  right: 0;
                  bottom: 0;
                  transform: translate(-60%, -10%);">
                <feather-icon
                  icon="DownloadIcon"
                  color="primary"
                  class="primary cursor-pointer"
                  style="width: 15px; height: 15px; color: #000000"/>
              </span>
            </div>
          </div>

          <div class="mr-3" v-if="formData['status'].value == 'pending' && tableData">
            <div class="tag">Compiler:</div>
            <div>
              <vs-button
                icon-pack="feather"
                icon="icon-rotate-cw"
                color="primary"
                type="filled"
                class="action-btn mr-4"
                @click="compileCNICData()"
                icon-after
                :disabled="(tableData && !tableData.length)">Compile Now</vs-button>
            </div>
          </div>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="form-actions flex justify-between py-0">
        <div class="flex vx-col-action">
          <vs-input
            icon-pack="feather"
            icon="icon-search"
            placeholder="Type here..."
            v-model="globalSearchTerm"
            class="is-label-placeholder searchBar-input"
            id="filter-text-box"
            v-on:input="onFilterTextBoxChanged()"/>
          <span class="br-line mr-2 ml-2"></span>
        </div>

        <div class="float-right flex">
          <vx-tooltip
            text="Download list"
            position="top"
            class="seperator-before">
            <vs-button
              class="iconOnly"
              color="dark"
              type="flat"
              icon-pack="feather"
              icon="icon-download"
              @click="downloadData()"></vs-button>
          </vx-tooltip>

          <vx-tooltip text="Reset Filters" position="top">
            <vs-button
              class="iconOnly"
              color="dark"
              type="flat"
              icon-pack="feather"
              icon="icon-refresh-ccw"
              @click="refreshPageWithFilters()"></vs-button>
          </vx-tooltip>
        </div>
      </div>

      <!-- Ag Grid -->
      <div id="grid-loader" class="vx-card vs-con-loading__container">
        <ag-grid-vue
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :components="components"
          :rowData="tableData"
          rowSelection="multiple"
          :enableRangeSelection="true"
          :suppressCopyRowsToClipboard="true"
          :suppressDragLeaveHidesColumns="true"
          :animateRows="false"
          :floatingFilter="true"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :suppressRowClickSelection="true"
          :rowClassRules="rowClassRules"
          :statusBar="statusBar"
          :sideBar="sideBar"
          :rowHeight="30"
          :headerHeight="30"
          :floatingFiltersHeight="35"
          :checkboxSelection="true"
          @filter-changed="onFilterChanged"
          @row-selected="onRowSelected"
          @pagination-changed="onPaginationChanged"
          @column-resized="onColumnResized">
        </ag-grid-vue>
        <div class="vx-row py-5">
          <div class="vx-col w-full">
            <vs-pagination
              :total="totalPages"
              :max="maxPageNumbers"
              class="custom-pagination"
              v-model="currentPage"/>
          </div>
        </div>
      </div>

      <custom-prompt
        :activePrompt.sync="customPrompt['activePrompt']"
        :title="customPrompt['title']"
        :buttonText="customPrompt['buttonText']"
        :type="customPrompt['type']"
        :color="customPrompt['color']"
        :classList="customPrompt['classList']">

        <div class="con-content" slot="content">
          <p>{{ customPromptError }}</p>
        </div>
      </custom-prompt>
    </div>

    <!-- Upload Email Confirmation Popup -->
    <vs-popup :active.sync="uploadEmailConfirmationPopup" title="Provide Information" class="upload-confirmation-popup">
      <vx-card>
        <div class="vx-row flex-wrap px-5">
          <p>Please upload a screenshot or PDF of the email sent to CNIC with the rebate settlement amounts for the period of June 2022.</p>
          
          <div class="mt-5 w-full">
            <label class="vs-input--label inline-flex pb-2">Upload CNIC Email Confirmation Document</label>
            <div class="mx-auto upload-input relative">
                <input :name="`uploadEmailConfirmation`" type="file" :id="`emailConfirmationFile`" :ref="`uploadEmailConfirmation`" style="cursor: pointer" v-validate="!fileLoaded ? 'required' : ''" class="absolute top-0 left-0 w-full h-full z-10 opacity-0" @change="handleFileChange($event, 'uploadEmailConfirmation')" />
                <vs-button class="upload-btn" type="filled" icon-pack="feather" icon="icon-file">Click or Drag & Drop PDF File Here</vs-button>
                <span class="text-danger text-sm" v-show="errors.has(`uploadEmailConfirmation`)">Required field</span>
                <div class="file-errors-wrap flex flex-wrap">
                    <ul v-show="formData.uploadEmailConfirmation['fileName']" class="pt-2 pr-5">
                        <li class="flex items-center">
                            <p class="pr-1" :class=" formData.uploadEmailConfirmation['fileTypeError'] || formData.uploadEmailConfirmation['fileSizeError'] ? 'color-gray' : 'text-primary' ">
                                {{ formData.uploadEmailConfirmation["fileName"] }}
                            </p>
                            <!-- NOTE: Hide remove icon if filesize or filetype error is there. -->
                            <vs-button v-show="!formData.uploadEmailConfirmation['fileTypeError'] && !formData.uploadEmailConfirmation['fileSizeError']" color="danger" type="flat" icon-pack="feather" icon="icon-x" class="remove-agt-file-btn" @click="removeFile()"></vs-button>
                        </li>
                    </ul>
                    <p v-show="formData.uploadEmailConfirmation['fileTypeError']" class="pt-2 text-danger">
                        {{ formData.uploadEmailConfirmation["fileTypeError"] }}
                    </p>
                    <p v-show="formData.uploadEmailConfirmation['fileSizeError']" class="pt-2 text-danger">
                        {{ formData.uploadEmailConfirmation["fileSizeError"] }}
                    </p>
                </div>
            </div>
          </div>
        </div>

        <div class="vx-row mt-6 mb-3">
          <vs-button class="mx-auto" type="filled" icon-pack="feather" @click="uploadEmailConfirmationFile()" :disabled="!formData.uploadEmailConfirmation['fileName']">Submit</vs-button>
        </div>
      </vx-card>
    </vs-popup>

    <!-- Upload Settlement Confirmation Popup -->
    <vs-popup :active.sync="uploadSettlementConfirmationPopup" title="Provide Information" class="upload-confirmation-popup">
      <vx-card>
        <div class="vx-row flex-wrap px-5">
          <p>Please upload a screenshot or PDF of the email sent by CNIC confirming the settlements have been made for the period of June 2022.</p>
          
          <div class="mt-5 w-full">
            <label class="vs-input--label inline-flex pb-2">Upload CNIC Settlement Confirmation Document</label>
            <div class="mx-auto upload-input relative">
              <input :name="`uploadSettlementConfirmation`" type="file" :id="`emailConfirmationFile`" :ref="`uploadSettlementConfirmation`" style="cursor: pointer" v-validate="!fileLoaded ? 'required' : ''" class="absolute top-0 left-0 w-full h-full z-10 opacity-0" @change="handleFileChange($event, 'uploadSettlementConfirmation')" />
              <vs-button class="upload-btn" type="filled" icon-pack="feather" icon="icon-file">Click or Drag & Drop PDF File Here</vs-button>
              <span class="text-danger text-sm" v-show="errors.has(`uploadSettlementConfirmation`)">Required field</span>
              <div class="file-errors-wrap flex flex-wrap">
                <ul v-show="formData.uploadSettlementConfirmation['fileName']" class="pt-2 pr-5">
                    <li class="flex items-center">
                        <p class="pr-1" :class=" formData.uploadSettlementConfirmation['fileTypeError'] || formData.uploadSettlementConfirmation['fileSizeError'] ? 'color-gray' : 'text-primary' ">
                            {{ formData.uploadSettlementConfirmation["fileName"] }}
                        </p>
                        <!-- NOTE: Hide remove icon if filesize or filetype error is there. -->
                        <vs-button v-show="!formData.uploadSettlementConfirmation['fileTypeError'] && !formData.uploadSettlementConfirmation['fileSizeError']" color="danger" type="flat" icon-pack="feather" icon="icon-x" class="remove-agt-file-btn" @click="removeFile()"></vs-button>
                    </li>
                </ul>
                <p v-show="formData.uploadSettlementConfirmation['fileTypeError']" class="pt-2 text-danger">
                    {{ formData.uploadSettlementConfirmation["fileTypeError"] }}
                </p>
                <p v-show="formData.uploadSettlementConfirmation['fileSizeError']" class="pt-2 text-danger">
                    {{ formData.uploadSettlementConfirmation["fileSizeError"] }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="vx-row mt-6 mb-3">
          <vs-button class="mx-auto" type="filled" icon-pack="feather" @click="uploadSettlementConfirmationFile()" :disabled="!formData.uploadSettlementConfirmation['fileName']">Submit</vs-button>
        </div>
      </vx-card>
    </vs-popup>

    <rebate-list-details></rebate-list-details>
  </div>
</template>

<script>
  import { AgGridVue } from 'ag-grid-vue';
  import 'ag-grid-enterprise';
  import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
  import '@/assets/scss/radix/extraComponents/agGridStyleOverride.scss';

  import RebateListDetails from "@/components/rebates/RebateListDetails.vue";
  import CellRendererViewActions from "@/components/ag-grid-tables/actions/CellRendererViewActions.vue";

  import vSelect from 'vue-select';
  import CustomPrompt from '@/components/CustomPrompt.vue';

  import statusConstants from "@/json/statusConstants.json";
  import moment from "moment";

  export default {
    name: 'CNICCompiler',
    data() {
      return this.initData();
    },
    components: {
      AgGridVue,
      'v-select': vSelect,
      CustomPrompt,
      RebateListDetails,
      CellRendererViewActions,
    },
    beforeMount() {
      // Table Data AXIOS Call
      this.populateTableData();

      // Reset movable columns on mobile
      this.toggleColumnMovable(this.windowWidth);

      (this.columnDefs = [
        {
          headerName: 'Partner Name',
          field: 'reseller_name',
          filter: 'agSetColumnFilter',
          minWidth: 214,
          width: 214,
          pinned: 'left',
        },
        {
          headerName: 'Period',
          field: 'period',
          filter: 'agSetColumnFilter',
          minWidth: 150,
          width: 250,
          cellRenderer: (data) => {
            return this.toDateMY(data.data.period);
          },
          valueGetter: (data) => {
            return this.toDateMY(data.data.period);
          }
        },
        {
          headerName: 'Rebate Amount',
          // TODO: Add column name after BE is updated
          field: 'rebate_amt',
          filter: 'agSetColumnFilter',
          minWidth: 130,
          cellRenderer: (data) => {
            if (data.data.rebate_amt) {
                return Number(parseFloat(data.data.rebate_amt).toFixed(2)).toLocaleString('en', {
                    minimumFractionDigits: 2
                });
            } else {
                return 0;
            }
          },
          valueGetter: (data) => {
            if (data.data.rebate_amt) {
                return Number(parseFloat(data.data.rebate_amt).toFixed(2)).toLocaleString('en', {
                    minimumFractionDigits: 2
                });
            } else {
                return 0;
            }
          },
        },
        {
          headerName: 'Account Manager',
          // TODO: Add column name after BE is updated
          field: 'am',
          filter: 'agSetColumnFilter',
          minWidth: 100,
          // width: 150,
        },
        {
          headerName: 'Status',
          field: 'status',
          filter: 'agSetColumnFilter',
          minWidth: 175,
          cellRenderer: (data) => {
            return Object.keys(statusConstants).find(key => statusConstants[key] == data.data.status);
          },
          valueGetter: (data) => {
          return Object.keys(statusConstants).find(key => statusConstants[key] == data.data.status);
        },
        },
        {
          headerName: "Status Duration (Days)",
          filter: "agSetColumnFilter",
          minWidth: 180,
          width: 180,
          cellRenderer: (data) => {
            if(data.data.status == statusConstants['Paid']) {
              return '-'
            } else {
              let days = moment().diff(moment(data.data.updated_at).format(), 'days');
              return days;
            }
          },
          valueGetter: (data) => {
            if(data.data.status == statusConstants['Paid']) {
              return 0
            } else {
              let days = moment().diff(moment(data.data.updated_at).format(), 'days');
              return days;
            }
          },
          cellClass: (data) => {
            if(data.data.status !== statusConstants['Paid']) {
              let days = moment().diff(moment(data.data.updated_at).format(), 'days');
              if(days > 2) {
                return 'cell-danger';
              }
            }
          }
        },
        {
          headerName: "Last Modified",
          field: "updated_at",
          filter: "agSetColumnFilter",
          minWidth: 180,
          width: 180,
        },
        {
          headerName: "Actions",
          minWidth: 120,
          width: 100,
          cellRendererFramework: "CellRendererViewActions",
          cellRendererParams: (rowData) => ({
            rowData,
            triggerEvent: 'openRebateListDetailsPopup'
          }),
      },
      ]),
        // Set Grid sidebar
        (this.sideBar = {
          toolPanels: [
            {
              id: 'columns',
              labelDefault: 'Columns',
              labelKey: 'columns',
              iconKey: 'columns',
              toolPanel: 'agColumnsToolPanel',
              toolPanelParams: {
                suppressRowGroups: true,
                suppressValues: true,
                suppressPivots: true,
                suppressPivotMode: true,
                suppressSideButtons: true,
                suppressColumnSelectAll: true,
                suppressColumnExpandAll: true,
              },
            },
          ],
        });
    },
    mounted() {
      this.gridApi = this.gridOptions.api;

      //agigrid loader
      this.gridApi.showLoadingOverlay();

      // Resize to fit columns
      this.sizeColumnsToFit();

      // Reset pinned columns on mobile
      this.toggleColumnPinned(this.windowWidth);

      // Bind Download Data Event Listeners
      this.$root.$on('downloadCNICCompilerListData', () => {
        var params = {
          onlySelected: true
        }
        
        this.gridApi.exportDataAsCsv(params);
      });

      // Bind Button Event Listeners
      this.$root.$on('tableRefresh', () => {
        this.refreshPage();
      });
    },
    methods: {
      initData() {
        return {
          gridOptions: {},
          maxPageNumbers: 7,
          gridApi: null,
          defaultColDef: {
            sortable: true,
            resizable: true,
            suppressMenu: true,
            suppressMovable: false,
            filterParams: {
              suppressAndOrCondition: true,
              newRowsAction: 'keep',
            },
          },
          rowClassRules: null,
          statusBar: null,
          sideBar: null,
          columnDefs: null,
          tableData: null,
          selectedPromos: [],
          // Cell Renderer Components
          components: {
          },
          globalSearchTerm: '',
          metaRebateAmount: '$100,000',
          metaPartnersInList: '35/37',
          metaDaysTillDeadline: '4',
          imgLoaded: false,
          cnicCompiler: {
            month: 'March',
            // TODO: Change to dynamic years dropdown
            year: '2023',
          },
          formData: {
            status: { label: 'Pending', value: 'pending', stage: 0 },
            recordID: null,
            uploadEmailConfirmation: {
              fileTypeError: null,
              fileSizeError: null,
              fileName: null,
              filePath: null,
              fileExtension: null,
            },
            uploadSettlementConfirmation: {
              fileTypeError: null,
              fileSizeError: null,
              fileName: null,
              filePath: null,
              fileExtension: null,
            },
            settlementConfirmation: {
              fileName: null,
              fileURL: null
            },
            emailConfirmation: {
              fileName: null,
              fileURL: null
            },
            cnicFormat: {
              fileName: null,
              fileURL: null
            },
          },
          previousStatus: null,
          fileLoaded: false,
          uploadEmailConfirmationPopup: false,
          uploadSettlementConfirmationPopup: false,
          // Custom Dialog props
          customPrompt: {
            activePrompt: false,
            title: '',
            buttonText: '',
            type: '',
            color: '',
            classList: '',
          },
          customPromptError: null
        };
      },
      onFilterTextBoxChanged() {
        this.gridApi.setQuickFilter(
          document.getElementById('filter-text-box').value
        );
        // this.deselectAllSelectedRows();
      },
      onPageSizeChanged() {
        var value = document.getElementById('page-size').value;
        this.gridApi.paginationSetPageSize(Number(value));
      },
      onPaginationChanged() {
        if (this.gridApi) {
          (this.totalRows = this.gridApi.paginationGetRowCount()),
            (this.currentPageSize = this.gridApi.paginationGetPageSize());
        }
      },
      onRowSelected(event) {
        var getStatus = this.gridApi
          .getSelectedNodes()
          .map((x) => x.data)
          .map((x) => x.status);
        // FIXME: Change Non editable condition according to rebates requirement
        getStatus.includes('expired')
          ? (this.selectedNonEditableRow = true)
          : (this.selectedNonEditableRow = false);
        if (event.node.selected) {
          // Push to selectedPromos
          this.selectedRowCount = this.gridApi.getSelectedNodes().length;
          if (this.selectedRowCount > 30) {
            event.node.setSelected(false);

            this.$vs.notify({
              time: 5000,
              color: 'warning',
              title: 'Warning',
              text: 'You may select only upto 30 rows',
            });
          }
        } else {
          this.selectedRowCount = this.gridApi.getSelectedNodes().length;
        }
      },
      onFilterChanged() {
        // this.deselectAllSelectedRows();
      },
      openLoadingInDiv() {
        this.$vs.loading({
          container: '#div-with-loading',
          scale: 0.8,
        });
      },
      hideLoadingInDiv() {
        this.$vs.loading.close('#div-with-loading > .con-vs-loading');
      },
      toggleColumnMovable(val) {
        if (val <= 576) {
          this.defaultColDef['suppressMovable'] = true;
        } else {
          this.defaultColDef['suppressMovable'] = false;
        }
      },
      toggleColumnPinned(val) {
        if (val <= 576) {
          this.maxPageNumbers = 4;
          this.gridOptions.columnApi.setColumnPinned('domain', null);
        } else {
          this.gridOptions.columnApi.setColumnPinned('domain', 'left');
        }
      },
      onColumnResized() {
        this.gridApi.resetRowHeights();
      },
      sizeColumnsToFit() {
        this.gridApi.sizeColumnsToFit();
      },
      // Refresh the page withou resetting filters
      refreshPage() {
        // this.initSelectedAllFlag();
        // Reset selection
        this.gridApi.deselectAll();
        // Reset sort
        this.gridApi.setSortModel(null);
        // Table Data AXIOS Call
        this.populateTableData();
      },
      // With filters for when we want to reset filters
      refreshPageWithFilters() {
        this.refreshPage();
        this.gridApi.setFilterModel(null);
      },
      downloadData() {
        this.$root.$emit('downloadCNICCompilerListData');
      },
      populateTableData() {
        this.$axiosSecure
          .get('/rebates/calculator/cnic')
          .then((response) => {
            this.tableData = response.data;

            this.getFileData();

            if (this.gridApi) {
              setTimeout(() => {
                // Set default filter to everything other than Paid
                var defaultFilter = {
                  status: {
                    type: 'set',
                    values: Object.keys(statusConstants).filter(key => key !== 'Paid')
                  },
                };
                this.gridApi.setFilterModel(defaultFilter);
              }, 100);
            }
          })
          .catch((error) => {
            // FIXME: Testing only
            this.tableData = [];

            if(error.response && error.response.status == 505) {
            // Reload because new data is available
            window.location.reload();
          } else {
              // Error notification
              this.$vs.notify({
                color: 'danger',
                title: 'Something went wrong',
                text: 'Please contact the server admin',
              });

              // Clear Listing Count
              this.$store.dispatch('clearListingCount');
            }
          });
      },
      getFileData() {
        // Get downloadable files if CNIC compilation is done
        this.$axiosSecure.get('/rebates/compile/cnic/file')
        .then((fileResponse) => {
          let cnicFormatURL, emailConfirmationURL, settlementConfirmationURL;
          cnicFormatURL = fileResponse.data.data ? fileResponse.data.data.compiled_file_url : null;
          emailConfirmationURL = fileResponse.data.data ? fileResponse.data.data.email_confirmation_file_url : null;
          settlementConfirmationURL = fileResponse.data.data ? fileResponse.data.data.cnic_confirmation_file_url : null;

          this.formData.recordID = fileResponse.data.data ? fileResponse.data.data.id : null;
          this.formData.status = fileResponse.data.data ? {
            value: fileResponse.data.data.status,
            label: this.toTitleCase(fileResponse.data.data.status),
            stage: this.formStatus.find(x => x.value == fileResponse.data.data.status).stage
          } : {
            label: 'Pending',
            value: 'pending',
            stage: 0
          };

          if(cnicFormatURL) {
            this.formData.cnicFormat['fileName'] = cnicFormatURL.split('/')[cnicFormatURL.split('/').length - 1];
            this.formData.cnicFormat['fileURL'] = fileResponse.data.data.compiled_file_url;
          }

          if(emailConfirmationURL) {
            this.formData.emailConfirmation['fileName'] = emailConfirmationURL.split('/')[emailConfirmationURL.split('/').length - 1];
            this.formData.emailConfirmation['fileURL'] = fileResponse.data.data.email_confirmation_file_url;
          }

          if(settlementConfirmationURL) {
            this.formData.settlementConfirmation['fileName'] = settlementConfirmationURL.split('/')[settlementConfirmationURL.split('/').length - 1];
            this.formData.settlementConfirmation['fileURL'] = fileResponse.data.data.cnic_confirmation_file_url;
          }
        })
        .catch((error) => {
          // TODO: Handle error
          console.log('error :>> ', error);
        })

        this.$axiosSecure.get('/rebates/compile/cnic/numbers')
        .then((statsResponse) => {
          if(statsResponse.data.data) {
            this.metaRebateAmount = '$'+statsResponse.data.data.rebate_amount;
            this.metaPartnersInList = statsResponse.data.data.total_partners;
            this.metaDaysTillDeadline = statsResponse.data.data.days_till_submission;
          }
        })
        .catch((error) => {
          // TODO: Handle error
          console.log('error :>> ', error);
        })
      },
      handleFileChange(event, type) {
        this.formData[type]['fileTypeError'] = '';
        this.formData[type]['fileSizeError'] = '';
        this.formData[type]['fileExtension'] = '';

        this.formData[type]['fileName'] = event.target.files[0].name;
        this.formData[type]['fileExtension'] = this.formData[type]['fileName']
          .split('.')
          .pop();

        // Check File Type
        this.formData[type]['filePath'] = event.target.value;

        // Allowed file types
        var allowedExtensions = /(\.pdf|\.jpg|\.jpeg|\.png)$/i;

        if (!allowedExtensions.exec(this.formData[type]['filePath'])) {
          this.formData[type]['fileTypeError'] =
            'Invalid file (Please upload .xlsx, .csv or .xls file under 25mb)';
          return false;
        }

        //Check File Size
        var ogFileSize = event.target.files[0].size;
        // console.log('size', ogFileSize);
        var fileSize = Math.round(ogFileSize / 1024);
        // console.log('fileSize', fileSize);

        if (fileSize >= 25600) {
          this.formData[type]['fileSizeError'] =
            'Please select a file under 25mb';
        }

        if (this.imgLoaded) {
          this.imgLoaded = false;
        }
      },
      removeFile(type) {
        (this.$refs[`uploadListFile-${type}`].value = null),
          (this.formData[type]['fileName'] = ''),
          (this.formData[type]['fileTypeError'] = ''),
          (this.formData[type]['fileSizeError'] = ''),
          (this.formData[type]['fileExtension'] = '');
      },
      customMonthFormatter(date) {
        return moment(date).format('MMMM YYYY');
      },
      compileCNICData() {
        this.openLoadingInDiv();
        
        setTimeout(() => {
          this.$axiosSecure.get('/rebates/compile/cnic')
          .then(response => {
            let url = response.data.data;
            this.formData.cnicFormat['fileURL'] = url;
            this.formData.cnicFormat['fileName'] = url.split('/')[url.split('/').length - 1];
            this.getFileData();
            this.hideLoadingInDiv();
          })
          .catch(error => {
            this.$vs.notify({
              color: 'danger',
              title: 'Something went wrong',
              text: 'Please contact the server admin',
            });
            this.hideLoadingInDiv();
            console.log(error);
          })
        }, 500)
      },
      downloadFile(url) {
        window.open(url, '_blank');
      },
      setPreviousStatus(previousStatus) {
        this.previousStatus = previousStatus;
      },
      openUploadConfirmationPopup() {
        if(this.formData.status.value == 'shared') {
          this.uploadEmailConfirmationPopup = true;
        } else if(this.formData.status.value == 'paid'){
          this.uploadSettlementConfirmationPopup = true;
        }
      },
      uploadEmailConfirmationFile() {
        let payload  = new FormData();
        payload.append('id', this.formData['recordID']);
        payload.append('status', this.formData['status'].value);
        payload.append('file', this.$refs.uploadEmailConfirmation.files[0]);
        payload.append('type', 'email');

        this.$axiosSecure.post('/rebates/compile/cnic/file', payload)
        .then((response) => {
          let url = response.data.data;
          this.formData['emailConfirmation']['fileURL'] = url;
          this.formData['emailConfirmation']['fileName'] = url.split('/')[url.split('/').length - 1];
          this.uploadEmailConfirmationPopup = false;
          this.getFileData();
        })
        .catch((error) => {
          if(error.response.data.type == 'Error') {
            this.customPromptError = error.response.data.message;
            this.customPrompt["type"] = "error";
            this.customPrompt["classList"] = "danger-prompt";
            this.customPrompt["color"] = "danger";
            this.customPrompt["activePrompt"] = true;
          }
        })
      },
      uploadSettlementConfirmationFile() {
        let payload  = new FormData();
        payload.append('id', this.formData['recordID']);
        payload.append('status', this.formData['status'].value);
        payload.append('file', this.$refs.uploadSettlementConfirmation.files[0]);
        payload.append('type', 'cnic');

        this.$axiosSecure.post('/rebates/compile/cnic/file', payload)
        .then((response) => {
          let url = response.data.data;
          this.formData['settlementConfirmation']['fileURL'] = url;
          this.formData['settlementConfirmation']['fileName'] = url.split('/')[url.split('/').length - 1];
          this.uploadSettlementConfirmationPopup = false;
          this.getFileData();
        })
        .catch((error) => {
          if(error.response.data.type == 'Error') {
            this.customPromptError = error.response.data.message;
            this.customPrompt["type"] = "error";
            this.customPrompt["classList"] = "danger-prompt";
            this.customPrompt["color"] = "danger";
            this.customPrompt["activePrompt"] = true;
          }
        })
      }
    },
    watch: {
      windowWidth(val) {
        // Toggle colummn movable
        this.toggleColumnMovable(val);
        // Toggle colummn pinning
        this.toggleColumnPinned(val);
      },
      uploadEmailConfirmationPopup(val) {
        if(!val && !this.formData['emailConfirmation']['fileName']) {
          this.formData['status'] = this.previousStatus;
        }
      },
      uploadSettlementConfirmationPopup(val) {
        if(!val && !this.formData['settlementConfirmation']['fileName']) {
          this.formData['status'] = this.previousStatus;
        }
      }
    },
    computed: {
      windowWidth: function () {
        return this.$store.state.windowWidth;
      },
      user_role() {
        return JSON.parse(localStorage.getItem('userDetails')).role;
      },
      user_id() {
        return JSON.parse(localStorage.getItem('userDetails')).id;
      },
      paginationPageSize() {
        if (this.gridApi) {
          return this.gridApi.paginationGetPageSize();
        } else {
          return 15;
        }
      },
      totalPages() {
        if (this.gridApi) {
          return this.gridApi.paginationGetTotalPages();
        } else {
          return 0;
        }
      },
      scrollbarTag() {
        return this.$store.getters.scrollbarTag;
      },
      currentPage: {
        get() {
          if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
          else return 1;
        },
        set(val) {
          this.gridApi.paginationGoToPage(val - 1);
        },
      },
      formStatus() {
        return [
          {
            label: 'Pending',
            value: 'pending',
            stage: 0
          },
          {
            label: 'Shared',
            value: 'shared',
            stage: 1
          },
          {
            label: 'Paid',
            value: 'paid',
            stage: 2
          }
        ]
      }
      // TODO: Uncomment when needed
      // formCNICCompilerMonths() {
      //   let months = [];

      //   for (let index = 0; index < 12; index++) {
      //     // NOTE: Hard setting the date so as to avoid the February bug
      //     let date = new Date('01-01-01');

      //     date.setMonth(index);

      //     months.push({
      //       value: date.toLocaleString('en-US', { month: 'long' }),
      //       label: date.toLocaleString('en-US', { month: 'long' })
      //     }) 
      //   }

      //   return months;
      // },
      // TODO: Populate years as per valid conditions
      // formCNICCompilerYears() {},
    },
    destroyed() {
      // Clear Listing Count
      this.$store.dispatch('clearListingCount');

      // Unbind Button Event Listeners
      this.$root.$off('downloadCNICCompilerListData');
      this.$root.$off('tableRefresh');
    },
  };
</script>